import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/modules/foundation/components/accordion';
import {ContentBlockHeading} from '@/modules/foundation/components/content-block-heading';
import type {KeyedArray} from '@/modules/foundation/shared/types';
import type {ContentBlockContainerProps} from '@/modules/page/components/content-blocks/block-container';
import {ContentBlockContainer} from '@/modules/page/components/content-blocks/block-container';

import type {FAQ} from '../../../types';

interface Props extends ContentBlockContainerProps {
	faqs: KeyedArray<FAQ>;
	heading?: string;
	anchorHeadings?: boolean;
	insideToc?: boolean;
}

export const FaqListArea = ({
	faqs,
	heading,
	anchorHeadings,
	options,
	insideToc,
}: Props) => {
	return (
		<ContentBlockContainer options={options} insideToc={insideToc}>
			<ContentBlockHeading
				heading={heading}
				anchorHeading={anchorHeadings}
			/>

			{faqs && faqs.length > 0 && (
				<Accordion type="single" collapsible>
					{faqs.map((faq) => (
						<AccordionItem key={faq._key} value={faq._key}>
							<AccordionTrigger>{faq.question}</AccordionTrigger>
							<AccordionContent>{faq.answer}</AccordionContent>
						</AccordionItem>
					))}
				</Accordion>
			)}
		</ContentBlockContainer>
	);
};
